module.exports = __webpack_public_path__ + "static/media/lion.65e4e1f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animalImage/img/lion.svg
// module id = 137
// module chunks = 0